var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":_vm.helpRedirect(),"target":"_blank"}},[_vm._v(" Ayuda ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }